import _ from 'lodash'
import Vue from 'vue'
import router from '@/router'

const error = {
  type: 'error',
  title:
    'พบรายชื่อจากการตรวจสอบ Name Screening ไม่อนุญาตให้ทำธุรกรรม กรุณาส่งเอกสารให้ Alert Handler Team เพื่อตรวจสอบ',
}

export const checkCustomerAmloSuccessMutation = (state, payload) => {
  const { field, result } = payload
  const isRiskInfoAllowed = _.get(result, 'riskInfo.isAllowed', false)
  state[field].data.isCheckAmloSuccess = true
  state[field].data.isPassAmlo = isRiskInfoAllowed
  if (!isRiskInfoAllowed) {
    const familyId = _.get(state.quotationInformation.data, 'familyQuotation.familyId', null)
    Vue.swal(error).then(() => {
      if (familyId) {
        router.push(`/insurance_family/${familyId}`)
      } else {
        router.push('/home')
      }
    })
  }
  state[field].isLoading = false
  state[field].isError = false
  state.isDisabledForm = !isRiskInfoAllowed
}
